<template>
<div class="chapter">
<div class="inner_page">
<template>
<p>
This page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it.<br/>
Thank you.
</p>
</template>
<script>

export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?830fd2b2